import usePermissions from "hooks/usePermissions";
import useArchiveConfig from "archive/hooks/useArchiveConfig";
const useExcludedStreams = () => {
  var _a;
  const { isPermitted } = usePermissions();
  const { data } = useArchiveConfig({ enabled: isPermitted("archiveconfig:read") });
  return (_a = data == null ? void 0 : data.excluded_streams) != null ? _a : [];
};
export default useExcludedStreams;
